export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEOVW5pQ05TLVVURjMyLUhDBgAAIBN4AAIQG4O8KYHVBoILgdRXAQBjBwAAMAgBgRYAAYESAAGBGgABgR4AAYEOAgGBCoOdcgGBAg==", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/UniCNS-UTF32-V.bcmap
// module id = 691
// module chunks = 502